export const RoundedRightArrow = (props: React.SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 26"
		fill="none"
		stroke="currentColor"
		strokeWidth="2"
		strokeLinecap="round"
		strokeLinejoin="round"
		{...props}
	>
		<path fillRule="evenodd" clipRule="evenodd" d="M14 16l6-6-6-6" />
		<path fillRule="evenodd" clipRule="evenodd" d="M4 21v-7a4 4 0 0 1 4-4h11" />
	</svg>
);
